<script>
import { mapGetters } from 'vuex'
import Filter from './Filter'
import Roles from '@/mixins/Roles'
import Config from '@/utils/metaConfig'
import InputButton from '@/components/input/Button'
export default {
    name: 'OrdersMarketplace',
    components: { InputButton },
    mixins: [Roles],

    data() {
        return {
            selectedServices: { 1: true, 2: false, 3: true, 4: false },
            selectedSort: {
                key: 'actual_asc',
                label: this.$t('ORDERS.SORT.ACTUAL_DESC'),
            },
            orderSort: [
                {
                    key: 'actual_asc',
                    label: this.$t('ORDERS.SORT.ACTUAL_ASC'),
                },
                {
                    key: 'actual_desc',
                    label: this.$t('ORDERS.SORT.ACTUAL_DESC'),
                },
                {
                    key: 'id_asc',
                    label: this.$t('ORDERS.SORT.ID_ASC'),
                },
                {
                    key: 'id_desc',
                    label: this.$t('ORDERS.SORT.ID_DESC'),
                },
            ],
            exportUrl: `${Config.getApiUrl()}/orders/export`,
        }
    },

    computed: {
        ...mapGetters(['services', 'orders', 'search', 'filters']),

        cardsCollapsed: {
            get() {
                return (
                    this.$store.state.general.cardsCollapsed == true ||
                    this.$store.state.general.cardsCollapsed == 'true'
                )
            },

            set(val) {
                this.$store.dispatch('setCardsCollapsed', val)
            },
        },
    },

    watch: {
        search() {
            this.fetch()
        },
        filters() {
            this.fetch()
        },
        selectedSort() {
            this.fetch()
        },
        selectedServices: {
            handler: 'saveAndFetch',
            deep: true,
        },
    },

    mounted() {
        this.$store.dispatch('filterComponent', Filter)
        if (!this.$route.params.page) {
            this.$router.replace({
                name: 'marketplace-paged',
                params: { page: 1 },
            })
        }
        const services = sessionStorage.getItem('orders-services')
        if (services) {
            try {
                this.selectedServices = JSON.parse(services)
            } catch (e) {
                console.log(e)
            }
        }
        this.fetch()
    },

    methods: {
        fetch(page) {
            page = page || this.$route.params.page
            if (page == undefined || page == null) page = 1
            if (
                this.$route.name != 'marketplace-paged' ||
                this.$route.params.page != page
            )
                this.$router.push({
                    name: 'marketplace-paged',
                    params: { page: page },
                })
            this.$store
                .dispatch('ordersFetchMarketplace', {
                    page: page,
                    search: this.search,
                    services: this.selectedServices,
                    filters: this.filters,
                    sort: this.selectedSort.key,
                })
                .then((data) => {
                    if (data && data.meta && data.meta.last_page < page) {
                        this.fetch(1)
                    }
                })
        },

        saveAndFetch() {
            window.sessionStorage.setItem(
                'orders-services',
                JSON.stringify(this.selectedServices)
            )
            this.fetch()
        },

        downloadXls() {
            this.$store.dispatch('ordersExport', {
                search: this.search,
                services: this.selectedServices,
                filters: this.filters,
                sort: this.selectedSort.key,
            })
        },
    },

    beforeRouteUpdate(to, from, next) {
        this.$store.dispatch('filterComponent', Filter)
        next()
    },
}
</script>

<template lang="pug">
    .m-4
        acrm-heading(:level="4") {{ $t('ORDERS.MARKETPLACE') }}
            small.ml-2.c-mid-5 {{ $t('ORDERS.ORDERS_TOTAL', { num: orders.meta.total }) }}
        .row.my-md-2.mx-n2.align-items-center
            .col-24.col-md-auto.px-2.d-flex.justify-content-between.justify-content-md-start
                acrm-input-checkbox.mr-md-3.py-2.py-md-0(v-for="service in services" :key="service.id" v-model="selectedServices[service.id]") {{ service.translated }}

        .row.my-md-2.mx-n2.align-items-center
            .col-24.col-md-7.col-lg-6.col-xl-5.px-2(v-if="hasRoleView('orderlist.filters.date')")
                acrm-multi-select.mb-0.mt-3.mt-md-0(
                    v-model="selectedSort"
                    :options="orderSort"
                    track-by="key"
                    option-label="label")
            .col-24.col-md-auto.px-2
                input-button.block-sm-down.mt-3.mt-md-0(
                    v-if="hasRole('ordercard.collapse')"
                    v-model="cardsCollapsed"
                    variant="primary"
                    :icon="cardsCollapsed ? 'unfold_more' : 'unfold_less'"
                    toggle outline sm)
                    template(v-if="cardsCollapsed") {{$t('BASE.SHOW_MORE')}}
                    template(v-else) {{$t('BASE.SHOW_LESS')}}

        acrm-order-card(v-for="order in orders.data" :key="order.id" :order="order" v-if="order.is_marketplace")
        acrm-panel.m-0(v-if="orders && orders.meta && orders.meta.last_page > 1")
            acrm-paginate(:data="orders.meta" @page="fetch")
</template>
